module.exports = __webpack_public_path__ + "img/劍道.bd766342.jpg";